/** Ensures `user.store` exists when the API only sends `user.stores` (employee admins). */
export function transformAuthUserJsonResponse(data: unknown): unknown {
  if (data == null) return data

  let parsed: Record<string, unknown>
  if (typeof data === 'string') {
    try {
      parsed = JSON.parse(data) as Record<string, unknown>
    } catch {
      return data
    }
  } else if (typeof data === 'object') {
    parsed = data as Record<string, unknown>
  } else {
    return data
  }

  const user = parsed.user as Record<string, unknown> | undefined
  if (!user || !Array.isArray(user.stores) || user.stores.length === 0) {
    return parsed
  }

  if (user.store && typeof user.store === 'object' && user.store !== null) {
    return parsed
  }

  const stores = user.stores as { id: number; name: string }[]
  // eslint-disable-next-line prettier/prettier
  const name = stores.length === 1 ? stores[0].name : stores.map(s => s.name).join(', ')

  return {
    ...parsed,
    user: {
      ...user,
      store: { id: stores[0].id, name },
    },
  }
}
